import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { TaktIdProvider, createStormTaktId, Flex, Menu, HelpTip, MenuButtonTrigger, MenuItemGroup, MenuItemLink, MenuItemButton } from '@amzn/storm-ui';
import styled from 'styled-components';
import { n as noop } from '../../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const DropdownActionButtonTrigger = /*#__PURE__*/styled(MenuButtonTrigger).withConfig({
  componentId: "sc-storm-ui-40025937__sc-130xkzq-0"
})([""]);
const DropdownActionItemButton = /*#__PURE__*/styled(MenuItemButton).withConfig({
  componentId: "sc-storm-ui-40025937__sc-130xkzq-1"
})([""]);
const DropdownActionItemGroup = /*#__PURE__*/styled(MenuItemGroup).withConfig({
  componentId: "sc-storm-ui-40025937__sc-130xkzq-2"
})([""]);
const DropdownActionItemLink = /*#__PURE__*/styled(MenuItemLink).withConfig({
  componentId: "sc-storm-ui-40025937__sc-130xkzq-3"
})([""]);
const DropdownAction = ({
  id,
  label,
  trigger,
  disabled,
  loading,
  children,
  helptipText,
  helptipTextPosition = 'right',
  taktId,
  taktValue,
  isOpen,
  onOpen = noop,
  onClose = noop,
  ...rest
}) => {
  const defaultTrigger = /*#__PURE__*/React__default.createElement(DropdownActionButtonTrigger, {
    loading: loading
  }, label);
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('page-header-dropdown-action')
  }, /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Menu, _extends({
    id: id,
    trigger: trigger || defaultTrigger,
    disabled: disabled,
    isOpen: isOpen
  }, rest), children), helptipText && /*#__PURE__*/React__default.createElement(HelpTip, {
    position: helptipTextPosition
  }, helptipText)));
};

export { DropdownAction as D, DropdownActionButtonTrigger as a, DropdownActionItemGroup as b, DropdownActionItemLink as c, DropdownActionItemButton as d };
//# sourceMappingURL=DropdownAction-f4X-CGBo.js.map
